<template>
  <Loader v-if="loading" :show="loading" />
  <MDBCard class="border-0" v-else>
    <CategoryTop
      small
      :title="$t('widgets.boosterCcs.historyTitle')"
      :breadcrumbs-parent-routes="['account', 'wholesaler']"
      :description="$t('widgets.boosterCcs.historyDescription')"
      content-class="px-4 mt-4"
      left-col="12"
      right-col="0"
    />

    <div class="px-4 pb-5">
      <div v-if="periods.length === 0" class="text-muted">
        {{ $t("widgets.boosterCcs.empty") }}
      </div>

      <MDBCard
        v-for="(period, index) in periods"
        :key="`${period.start_date}-${index}`"
        class="kpi-card mb-4"
      >
        <MDBCardBody>
          <BoosterCcsPeriodBlock :period="period" :show-explore="index === 0" />
        </MDBCardBody>
      </MDBCard>
    </div>
  </MDBCard>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { MDBCard, MDBCardBody } from "mdb-vue-ui-kit";
import CategoryTop from "@/components/General/CategoryTop/index.vue";
import Loader from "@/components/General/Loader/index.vue";
import BoosterCcsPeriodBlock from "@/components/Widgets/BoosterCcsPeriodBlock.vue";
import { WIDGET_SIGNATURES } from "@/utils/widgets";

const store = useStore();

const loading = computed(() => store.getters["kpiDashboard/widgetsLoading"]);
const widgets = computed(() => store.getters["kpiDashboard/widgets"] || []);

const boosterWidget = computed(() =>
  widgets.value.find((w) => w.signature === WIDGET_SIGNATURES.booster_ccs_widget)
);

const periods = computed(() => {
  const list = boosterWidget.value?.data?.periods;
  return Array.isArray(list) ? list : [];
});

onMounted(() => {
  if (!boosterWidget.value) {
    store.dispatch("kpiDashboard/fetchDashboard");
  }
});
</script>

<style scoped lang="scss">
.kpi-card {
  box-shadow: none;
  border: 1px solid #e5e5e5;
}
</style>
